export const episodeCodeToDisplay = episodeCode => {
  if (!episodeCode || !/^[a-z]/i.test(episodeCode)) return episodeCode;

  const [, letters, suffix] = episodeCode.match(/^([a-z]+)\s*(.*)$/i);
  return suffix ? `${letters.toUpperCase()} ${suffix}` : letters.toUpperCase();
};

export const episodeCodeToStorage = episodeCode => {
  if (!episodeCode || !/^[a-z]/i.test(episodeCode)) return episodeCode;

  return episodeCode.toLowerCase().replace(/\s+/g, '');
};

export default function EpisodeCode({episodeCode}) {
  return episodeCodeToDisplay(episodeCode);
}
